
const getExchangeName = (exchangeName: string | undefined) => {
    if(exchangeName && exchangeName.length > 0) {
      const updatedName = exchangeName.replaceAll('-', ' ').toLocaleUpperCase()
      return updatedName;
    }
    return '';
};

export default getExchangeName;